// extracted by mini-css-extract-plugin
export default {"title_container":"SlsTitle_title_container__9xBif","title":"SlsTitle_title__R1yLY","fadeIn":"SlsTitle_fadeIn__5UqSN","text":"SlsTitle_text__IHtlc"};